<button id="veener-loader-btn" aria-disabled="true" disabled type="button" class="veener-loader-btn">
  <mat-spinner diameter="24" color="#a3a3a3"></mat-spinner>
</button>
